import { useSelector } from "react-redux";
import { EXAMS_STATUS } from "../../../config/constants";
import { selectTranslations } from "../../../services/i18n/i18nSlice";
import { Link, useNavigate } from "react-router-dom";

import modules_img from '../../../assets/images/exams/grid.svg'
import questions_img from '../../../assets/images/exams/questions.svg'
import calendar_img from '../../../assets/images/exams/calendar.svg'

export default function ExamListCard (props) {
    
    const t = useSelector(selectTranslations)
    const navigate = useNavigate()

    const openExam = () => {
        navigate(`/exams/details/${props?.data?.exam_id}`)
    }

    return(
        <div className={"exam_card " + (props.index === 0 ? "exams-step-1 " : "") + (props.selectedExam ? "selected_exam" : '')} key={props?.data?.exam_id} onClick={props.handleSelectExam} onDoubleClick={openExam}>
            <div className="d-flex justify-content-between align-items-start">
                <span className="exam_title">{props?.data?.title}</span>

                <div className="d-flex align-items-center">
                    {
                        props.data?.is_customizable ?
                            <span className='status_label me-2' style={{color:"#0A5ADB", background:"#E4EFFF"}}>{t.exams.customizable_badge}</span>
                        : null
                    }
                    {
                        props.data?.state === "ready" && props.data?.end_date && new Date(props.data?.end_date) <= new Date() ?
                            <span className='status_label' style={{color:`${EXAMS_STATUS['past']?.color}`, background: `${EXAMS_STATUS['past']?.background}`}}>{t.exams.past}</span>
                        :
                            <span className='status_label' style={{color:`${EXAMS_STATUS[props.data?.state]?.color}`, background: `${EXAMS_STATUS[props.data?.state]?.background}`}}>{t.exams[props.data?.state]}</span>
                    }
                </div>
            </div>
            <hr />
            <div>
                <img src={modules_img} alt=""/>
                <span className="ms-1"><strong>{props.data?.modules_count} </strong>{t.exam.modules}</span>
            </div>
            <div className="mt-2">
                <img src={questions_img} alt=""/>
                <span className="ms-1"><strong>{props.data?.questions_count} </strong>{t.exam.questions}</span>
            </div>
        </div>
    )
}